import { dataMember, required, typedArray } from 'santee-dcts';
import { EQueryAccessionInfo } from '../../shared/e-query-accession-info';
import { ActiveEQuery } from './active-e-query';

export class EscalationContactCenter {
    @dataMember()
    @required()
    public emailAddress: string;
    @dataMember()
    @required()
    public lastName: string;
    @dataMember()
    @required()
    public role: string;
}

export class QueryContactCenter {
    @dataMember()
    @required()
    public query: string;
    @dataMember()
    @required()
    public issueType: string;
    @dataMember()
    @required()
    public issueDesc: string;
    @dataMember()
    @required({ nullable: true })
    public mask: string;
    @dataMember()
    @required({ nullable: true })
    public maskDesc: string;
}

export class EQueryStageData {
    @dataMember()
    @required()
    public projectId: string;
    @dataMember()
    @required()
    public accessionSubject: EQueryAccessionInfo;
    @dataMember()
    @required()
    @typedArray(EscalationContactCenter)
    public escalations: EscalationContactCenter[];
    @dataMember()
    @required({nullable: true})
    public escalationsErrorMessage: string;
    @dataMember()
    @required()
    @typedArray(QueryContactCenter)
    public queries: QueryContactCenter[];
}

export class EQueryStageReadModel {
    @dataMember()
    @required()
    public eQueryStage: EQueryStageData;

    @dataMember()
    @required({ nullable: true })
    public activeEQuery: ActiveEQuery;
}
